import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { MailTemplate } from "../models/mail-template.model";
import { Observable } from "rxjs";
import { MailBalise } from "../models/mail-balise.model";
import { MailCategorieBalise } from "../models/mail-categorie-balise.model";

@Injectable({
    providedIn: 'root'
})
export class ParamEmailsService {
    private readonly API_URL = '/api/mail/private';
    private readonly http = inject(HttpClient);

    /**
     * Récupère la liste des templates
     */
    getTemplates(): Observable<MailTemplate[]> {
        return this.http.get<MailTemplate[]>(`${this.API_URL}/template`);
    }

    /**
     * Récupère la liste des templates
     */
    getBalises(): Observable<MailBalise[]> {
        return this.http.get<MailBalise[]>(`${this.API_URL}/balise`);
    }

    /**
     * Récupère la liste des templates
     */
    getCategorieBalises(): Observable<MailCategorieBalise[]> {
        return this.http.get<MailCategorieBalise[]>(`${this.API_URL}/categorie-balise`);
    }

    updateTemplate(id: number, template: MailTemplate) {
        return this.http.put<MailTemplate>(`${this.API_URL}/template/${id}`, template);
    }

    createTemplate(template: MailTemplate) {
        return this.http.post<MailTemplate>(
            `${this.API_URL}/template`,
            template
        );
    }

}